export default __webpack_public_path__ + "static/media/Foto-08.072f912f.png";